import { Controller } from "@hotwired/stimulus";

/**
 * /leaderboards: scrolls each filter row so its active chip is in view (the game row scrolls sideways on
 * phones), and on phones shows the "Jump to me" bar while the player's own row is off screen. Lives inside
 * the Turbo Frame, so a filter swap reconnects it with the new board.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["activeChip", "you", "bar"];

  declare readonly activeChipTargets: HTMLElement[];
  declare readonly hasYouTarget: boolean;
  declare readonly youTarget: HTMLElement;
  declare readonly hasBarTarget: boolean;
  declare readonly barTarget: HTMLElement;

  private observer: IntersectionObserver | null = null;

  connect() {
    this.activeChipTargets.forEach((chip) => {
      const row = chip.parentElement;
      if (!row || row.scrollWidth <= row.clientWidth) return;

      // Only the row moves, never the page
      row.scrollLeft = chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2;
    });

    if (!this.hasYouTarget || !this.hasBarTarget) return;

    this.observer = new IntersectionObserver(([entry]) => {
      this.barTarget.classList.toggle("hidden", entry.isIntersecting);
      this.barTarget.classList.toggle("flex", !entry.isIntersecting);
    });
    this.observer.observe(this.youTarget);
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = null;
  }

  jump(event: Event) {
    event.preventDefault();
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.youTarget.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
  }
}
